declare namespace $ {

	export class $easyreels_labeler_moment extends $mol_labeler {
		shown_value( ): string
		title( ): string
		value( ): string
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=moment.view.tree.d.ts.map